// noinspection DuplicatedCode
import React, { useEffect, useState } from "react";

import { Card } from "@material-tailwind/react";
import Button from "@material-tailwind/react/Button";
import Modal from "@material-tailwind/react/Modal";
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import { useMutation } from "@tanstack/react-query";
import { BiArrowBack } from "react-icons/bi";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { Colors } from "../../../assets/Colors";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import { isRequired, useForm } from "../../../components/isRequired";
import { DynamicTableSimple } from "../../../components/tablecard/DynamicTable";
import { toast } from "react-toastify";
import { useUserBisnisUnit } from "../../../hooks/useUserBisnisUnit";

import {
  fetchGet,
  fetchPost,
  fetchPostMultipartSeaweed,
  fetchPut,
} from "../../../fetchers";

// Karyawan yang boleh memilih sendiri Bagian MSR (keputusan user 2026-10-27); kunci = Nik.
// Harus sama dengan msrBagianDipilih di backend (models/procurement/msr_bagian_akses.go).
const NIK_PILIH_BAGIAN = {
  "SO-20250803": ["B0018", "B0008", "B0001"], // Ari Nugroho: FM-ESM, FM-FI, FM-IT
};

const InsertPurchaseRequisitionPage = ({}) => {
  let initialState = {
    BisnisUnitID: "",
    DatePR: new Date(),
  };

  let initialStateModal = {
    SDTDate: new Date(),
    Stock: 0,
    MinQty: 0,
    QtyTransit: 0,
    SaldoAkhir: 0,
    AvailableStock: 0, // Stock yang tersedia untuk digunakan (SaldoAkhir - MinQty)
    Qty: 0,
    JumlahPO: 0
  };

  const validations = [
    ({ BagianID }) =>
      isRequired(BagianID) || { BagianID: "Nama BagianID wajib diisi" },
    ({ BisnisUnitID }) =>
      isRequired(BisnisUnitID) || { BisnisUnitID: "BisnisUnitID wajib diisi" },
    ({ Remarks }) => isRequired(Remarks) || { Remarks: "Remarks wajib diisi" },
    ({ Requester }) =>
      isRequired(Requester) || { Requester: "Requester wajib diisi" },
    ({ Sifat }) => isRequired(Sifat) || { Sifat: "Sifat wajib diisi" },
    ({ Tipe }) => isRequired(Tipe) || { Tipe: "Tipe wajib diisi" },
    ({ PerkiraanHarga }) =>
      isRequired(PerkiraanHarga) || {
        PerkiraanHarga: "Perkiraan Harga wajib diisi",
      },
  ];

  const {
    changed,
    values,
    isValid,
    touched,
    submitHandler,
    customHandler,
    changeHandler,
    errors,
    blastChange,
    multiFieldHandler,
  } = useForm(initialState, validations);

  const barang = useMutation((formData) => fetchGet("Master/Barang/min"));
  const [buttonTouched, setButtonTouched] = useState(false);
  const [stockFinder, setStockFinder] = useState(0);
  const [qtynull, setqtynull] = useState(false);
  const [barangexist, setbarangexist] = useState(false);
  const [tableError, setTableError] = useState(""); // State untuk error table kosong
  // Popup blokir: barang masih Transit In / Transit Out di divisi yang sama.
  const [transitBlock, setTransitBlock] = useState(null);

  const [detail, setDetail] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [modalDetail, setModalDetail] = useState(initialStateModal);
  const [modalID, setModalID] = useState(0);
  const [showterminForm, setshowterminForm] = useState(false);
  const [errorTermin, seterrorTermin] = useState("");
  // Daftar downpayment (uang muka) yang boleh direferensikan MSR ini. Backend yang
  // menyaring: hanya milik Bagian ini, sudah disetujui, dan belum dipakai MSR lain.
  const [downpaymentList, setDownpaymentList] = useState([]);
  
  const ModalOpener = (detail) => {
    if (!values["BagianID"]) {
      toast.error("Pilih Bagian terlebih dahulu!", {
        position: "bottom-right",
        autoClose: 5000,
        theme: "light",
      });
      return;
    }
    setShowModal(true);
  };

  // Ganti Bagian (hanya user berhak pilih): item yang sudah ada milik Bagian lama,
  // jadi daftar dikosongkan setelah konfirmasi.
  const gantiBagian = (value, name) => {
    if (value === values["BagianID"]) return;
    if (detail.length > 0) {
      const ok = window.confirm(
        "Mengganti Bagian akan mengosongkan daftar barang yang sudah diisi. Lanjutkan?"
      );
      if (!ok) return;
      setDetail([]);
    }
    // Kategori/Barang yang tersisa di modal milik Bagian lama.
    setModalDetail(initialStateModal);
    customHandler(value, name);
  };
  const param = useLocation();
  const params = useParams();
  // Bagian user login. JANGAN baca localStorage langsung: isinya snapshot saat
  // login yang tak pernah disegarkan — sesi sisa akun lain membuat Bagian MSR
  // terisi bagian orang itu, dan field ini disabled sehingga tak bisa dikoreksi.
  const { bagianID: userBagianID } = useUserBisnisUnit();
  // Bagian yang boleh dipilih user ini saat MSR BARU (undefined = terkunci ke Bagian sendiri).
  // Saat mengedit, Bagian ikut dokumen dan tetap terkunci.
  const bagianPilihan = (() => {
    if (params.transid) return undefined;
    try {
      const nik = (JSON.parse(localStorage.getItem("user") || "null") || {}).Nik;
      return NIK_PILIH_BAGIAN[nik];
    } catch {
      return undefined;
    }
  })();

  const mutation = useMutation((formData) =>
    fetchPost("Master/UserPC", formData)
  );
  const mutationAdd = useMutation((formData) =>
    fetchPost("Procurement/PurchaseRequisition", formData)
  );
  const mutationGet = useMutation((formData) =>
    fetchGet("Procurement/PurchaseRequisition/" + formData)
  );
  const mutationUpdate = useMutation((formData) =>
    fetchPut("Procurement/PurchaseRequisition", formData)
  );
  // Bisnis Unit wajib ikut: stok itu per gudang. Tanpa ini form satu unit bisa
  // menampilkan saldo milik unit lain dan mengira barangnya tersedia.
  const mutationStock = useMutation((formData) =>
    fetchGet(
      "Procurement/GoodsStock/" +
        formData +
        "?bisnisunit=" +
        encodeURIComponent(values["BisnisUnitID"] || "")
    )
  );
  const mutationFile = useMutation((formData) =>
    fetchPostMultipartSeaweed(formData)
  );
  const mutationDownpayment = useMutation((qs) =>
    fetchGet("Accounting/Downpayment/msr" + qs)
  );

  const customHandlers = (event) => {
    customHandler(event.value, "PerkiraanHarga");
  };

  const ModalEdit = (detail, id) => {
    setModalID(id);
    setModalDetail(detail);
    setShowModal(true);
    setShowModalEdit(true);
  };

  const ModalDelete = (id) => {
    let newDetail = [...detail];
    newDetail.splice(id, 1);
    setDetail(newDetail);
    // Reset error jika table sudah ada data
    if (newDetail.length > 0) {
      setTableError("");
    }
  };

  const ChangeTipe = (e) => {
    if (e === "Barang") {
      setshowterminForm(false);
      customHandler(e, "Tipe");
    } else {
      setshowterminForm(true);
      // Jasa: termin dikunci 0 di sini. Saat MSR dibuat, pemohon belum tahu akan
      // dipecah berapa termin — pembagian itu baru diketahui waktu Price Comparison,
      // dan di sanalah termin wajib diisi hingga totalnya 100%.
      //
      // WAJIB satu multiFieldHandler, bukan empat customHandler beruntun:
      // customHandler menyusun ulang dari `values` yang sama (stale closure),
      // sehingga panggilan berikutnya menimpa yang sebelumnya — Tipe pun ikut hilang.
      // Nilainya string "0", bukan angka 0: backend memetakan Termin1..3 ke
      // string dan baru di-Atoi sendiri, jadi angka telanjang ditolak json.Unmarshal.
      multiFieldHandler({ Tipe: e, Termin1: "0", Termin2: "0", Termin3: "0" });
    }
  };

  const navigate = useNavigate();

  // Fungsi untuk menghitung Available Stock (SaldoAkhir - MinQty)
  // Stock tersedia = (Saldo Akhir + Qty Transit) - Min Qty
  const calculateAvailableStock = (saldoAkhir, minQty, qtyTransit = 0) => {
    const saldo = parseFloat(saldoAkhir) || 0;
    const min = parseFloat(minQty) || 0;
    const transit = parseFloat(qtyTransit) || 0;
    const available = saldo + transit - min;
    
    // Available stock tidak boleh negatif
    return available > 0 ? available : 0;
  };

  // Fungsi perhitungan JumlahPO yang diperbaiki sesuai requirement
  const calculateJumlahPO = (availableStock, qty) => {
    const stockNum = parseFloat(availableStock) || 0;
    const qtyNum = parseFloat(qty) || 0;
    
    console.log("Calculating JumlahPO:", { availableStock: stockNum, qty: qtyNum });
    
    // Jika stock CUKUP (stock >= qty), maka JumlahPO = 0
    // Jika stock KURANG (stock < qty), maka JumlahPO = qty
    if (stockNum >= qtyNum) {
      return 0;
    } else {
      return qtyNum;
    }
  };

  // Fungsi untuk update semua data dengan perhitungan yang benar
  const updateAllData = (data) => {
    return data.map(item => {
      const availableStock = calculateAvailableStock(
        item.SaldoAkhir,
        item.MinQty,
        item.AturanTransit === false ? 0 : item.QtyTransit
      );
      const jumlahPO = calculateJumlahPO(availableStock, item.Qty);
      
      return {
        ...item,
        Stock: availableStock, // Tampilkan available stock di table
        AvailableStock: availableStock,
        JumlahPO: jumlahPO
      };
    });
  };

  useEffect(() => {
    barang.mutate();
    if (params.transid) {
      mutationGet.mutate(params.transid.replaceAll("-", "/"));
    }
  }, []);

  // Isi Bisnis Unit (dari URL) & Bagian (bagian user login) dalam SATU patch.
  //
  // Dua alasan harus satu patch dan bukan customHandler beruntun: setiap handler
  // useForm menyalin `values` dari closure render-nya sendiri, jadi panggilan
  // kedua menimpa hasil panggilan pertama — versi lama kehilangan BisnisUnitID
  // dari URL karena langsung disusul pengisian BagianID.
  //
  // BagianID dipasang hanya untuk MSR BARU: saat mengedit, Bagian ikut dokumen
  // yang dimuat (blastChange), bukan bagian user yang sedang membuka. Nilainya
  // datang dari useUserBisnisUnit (bertanya ke server), bukan snapshot login.
  useEffect(() => {
    const patch = {};
    if (params.id && values["BisnisUnitID"] !== params.id) {
      patch.BisnisUnitID = params.id;
    }
    if (
      !params.transid &&
      !bagianPilihan &&
      userBagianID &&
      values["BagianID"] !== userBagianID
    ) {
      patch.BagianID = userBagianID;
    }
    if (Object.keys(patch).length > 0) {
      multiFieldHandler(patch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userBagianID]);

  // Muat daftar downpayment setiap kali Bagian diketahui/berubah. Bagian pada form
  // ini terkunci ke bagian milik pengguna, jadi praktiknya jalan sekali — tapi saat
  // MSR lama dibuka, BagianID baru terisi setelah data datang, sehingga efek ini
  // harus bergantung pada nilainya, bukan cuma dijalankan saat mount.
  useEffect(() => {
    const bagian = values["BagianID"];
    if (!bagian) return;

    // pr= MSR yang sedang diedit: DP miliknya sendiri tetap ditampilkan, kalau tidak
    // pilihan yang sudah tersimpan hilang dari dropdown saat form dibuka ulang.
    let qs = "?bagian=" + encodeURIComponent(bagian);
    if (params.transid) {
      qs += "&pr=" + encodeURIComponent(params.transid.replaceAll("-", "/"));
    }

    mutationDownpayment.mutate(qs, {
      onSuccess: (res) => {
        if (res && res.status === "Success" && Array.isArray(res.data)) {
          setDownpaymentList(res.data);
        } else {
          setDownpaymentList([]);
        }
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values["BagianID"]]);

  useEffect(() => {
    if (mutationUpdate) {
      if (mutationUpdate.isSuccess) {
        navigate(
          "/procurment/transaction/Material-and-Services-Request/" +
            values["BisnisUnitID"]
        );
      }
    }
  }, [mutationUpdate.status]);

  useEffect(() => {
    if (mutationAdd) {
      if (mutationAdd.isSuccess) {
        navigate(
          "/procurment/transaction/Material-and-Services-Request/" +
            values["BisnisUnitID"]
        );
      }
    }
  }, [mutationAdd.status]);

  useEffect(() => {
    if (mutationStock) {
      if (mutationStock.isSuccess) {
        if (mutationStock.data) {
          let newValues = [...detail];
          
          // Simpan semua data stock yang didapat dari API
          newValues[stockFinder]["SaldoAkhir"] = mutationStock.data.data["SaldoAkhir"];
          newValues[stockFinder]["MinQty"] = mutationStock.data.data["MinQty"] || 0;
          newValues[stockFinder]["QtyTransit"] = mutationStock.data.data["QtyBelumDiterima"] || 0;
          
          // Hitung available stock (SaldoAkhir - MinQty)
          const availableStock = calculateAvailableStock(
            newValues[stockFinder]["SaldoAkhir"],
            newValues[stockFinder]["MinQty"],
            newValues[stockFinder]["QtyTransit"]
          );
          newValues[stockFinder]["AvailableStock"] = availableStock;
          newValues[stockFinder]["Stock"] = availableStock; // Untuk display di table
          
          // Hitung ulang JumlahPO dengan available stock
          newValues[stockFinder]["JumlahPO"] = calculateJumlahPO(
            availableStock,
            newValues[stockFinder]["Qty"]
          );
          
          console.log("Updated item with new stock logic:", newValues[stockFinder]);
          setDetail(newValues);
          
          // Reset error jika table sudah ada data
          if (newValues.length > 0) {
            setTableError("");
          }
        }
      }
    }
  }, [mutationStock.data]);

  useEffect(() => {
    if (mutationGet.data) {
      const dataWithCalculations = updateAllData(mutationGet.data.data.PRList);
      setDetail(dataWithCalculations);
      blastChange(mutationGet.data.data);
      
      // Reset error jika ada data
      if (dataWithCalculations.length > 0) {
        setTableError("");
      }
    }
  }, [mutationGet.status]);

  // Update header untuk menampilkan Stock (yang sebenarnya adalah Available Stock)
  const header = [
    { name: "Barang", key: "BarangID", modifiers: "Barang" },
    { name: "Satuan", key: "BarangID", modifiers: "BarangSatuan" },
    { name: "Saldo Akhir", key: "SaldoAkhir", modifiers: "number" },
    { name: "Min Qty", key: "MinQty", modifiers: "number" },
    { name: "Qty Transit", key: "QtyTransit", modifiers: "number" },
    { name: "Stock Tersedia", key: "Stock", modifiers: "number" },
    { name: "Jumlah Pengajuan", key: "Qty", modifiers: "number" },
    { name: "Jumlah PO", key: "JumlahPO", modifiers: "number" },
    { name: "Keterangan", key: "Keterangan", modifiers: "Text" },
    { name: "Tanggal dibutuhkan", key: "SDTDate", modifiers: "dateOnly" },
    { name: "Spesifikasi", key: "Specification", modifiers: "Text" },
    { name: "Aksi", key: "EditDelete", modifiers: "EditDelete" },
  ];

  const modalHandler = (value, names) => {
    const newValues = { ...modalDetail, [names]: value };

    // Otomatis hitung Available Stock dan JumlahPO ketika data berubah
    if (names === "SaldoAkhir" || names === "MinQty" || names === "QtyTransit") {
      const availableStock = calculateAvailableStock(
        names === "SaldoAkhir" ? value : newValues.SaldoAkhir,
        names === "MinQty" ? value : newValues.MinQty,
        newValues.QtyTransit
      );
      newValues.AvailableStock = availableStock;
      newValues.Stock = availableStock;
      newValues.JumlahPO = calculateJumlahPO(availableStock, newValues.Qty);
    }
    
    // Otomatis hitung JumlahPO ketika Qty berubah
    if (names === "Qty") {
      newValues.JumlahPO = calculateJumlahPO(newValues.AvailableStock, value);
    }

    setModalDetail(newValues);
  };

  const modalHandlerText = (event) => {
    const newValues = {
      ...modalDetail,
      [event.target.name]: event.target.value,
    };

    // Otomatis hitung Available Stock dan JumlahPO ketika data berubah
    if (event.target.name === "SaldoAkhir" || event.target.name === "MinQty" || event.target.name === "QtyTransit") {
      const availableStock = calculateAvailableStock(
        event.target.name === "SaldoAkhir" ? event.target.value : newValues.SaldoAkhir,
        event.target.name === "MinQty" ? event.target.value : newValues.MinQty,
        newValues.QtyTransit
      );
      newValues.AvailableStock = availableStock;
      newValues.Stock = availableStock;
      newValues.JumlahPO = calculateJumlahPO(availableStock, newValues.Qty);
    }
    
    // Otomatis hitung JumlahPO ketika Qty berubah
    if (event.target.name === "Qty") {
      newValues.JumlahPO = calculateJumlahPO(newValues.AvailableStock, event.target.value);
    }

    setModalDetail(newValues);
  };

  // Update input builder untuk modal - HANYA tampilkan field yang diperlukan
  const inputBuilder = [
    {
      type: "Kelompok",
      name: "Kategory",
      title: "Kategory Barang",
      handler: modalHandler,
      size: "full",
      required: false,
      disabled: !values["BagianID"],
      edit: false,
      bagianID: values["BagianID"],
    },
    {
      type: "BarangAgregate",
      name: "BarangID",
      title: "Barang",
      handler: modalHandler,
      size: "full",
      required: true,
      disabled: !values["BagianID"],
      edit: false,
      bagianID: values["BagianID"],
    },
    {
      type: "number",
      name: "Qty",
      title: "Jumlah Pengajuan *",
      handler: modalHandlerText,
      size: "full",
      required: true, // Wajib diisi (mandatory)
      disabled: false,
      edit: false,
    },
    {
      type: "dateOnly",
      name: "SDTDate",
      title: "Tanggal dibutuhkan",
      handler: modalHandler,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "text",
      name: "Specification",
      title: "Spesifikasi",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
  ];

  const Kirim = () => {
    // Validasi table tidak boleh kosong
    if (detail.length === 0) {
      setTableError("Table tidak boleh kosong. Silakan tambahkan minimal satu item barang.");
      toast.error("Table tidak boleh kosong!", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    // Validasi form
    if (!isValid) {
      toast.error("Form tidak terisi dengan benar!", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    console.log("Data yang dikirim:", { values, detail });
    
    let newValues = { ...values };
    try {
      newValues["DatePR"] = newValues["DatePR"].toISOString();
    } catch (err) {}

    // Pastikan semua data detail memiliki perhitungan yang benar sebelum dikirim
    const validatedDetail = updateAllData(detail);
    newValues["PRList"] = validatedDetail;
    
    let r = (Math.random() + 1).toString(36).substring(7);

    if (newValues["NamaFile"]) {
      try {
        const { v4: uuidv4 } = require("uuid");

        const uuid = uuidv4();
        let formData = new FormData();
        const nama =
          uuid + "-" + newValues["NamaFile"].name.replaceAll(" ", "_");
        formData.append("file", newValues["NamaFile"], nama);
        mutationFile.mutate(formData);
        newValues["NamaFile"] = nama;
      } catch (error) {
        console.log(error);
      }
    }
    
    if (params.transid) {
      newValues["Status"] = "1";
      mutationUpdate.mutate(newValues);
    } else {
      mutationAdd.mutate(newValues);
    }
  };

  function hasDuplicateBarangID(arr) {
    const seenIDs = new Set();
    for (const obj of arr) {
      if (seenIDs.has(obj.BarangID)) {
        return true; // Found a duplicate BarangID
      } else {
        seenIDs.add(obj.BarangID);
      }
    }

    return false; // No duplicate BarangID found
  }

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-col mt-5">
                <div className="flex w-full justify-end flex-col sm:flex-row ">
                  <button
                    onClick={() =>
                      navigate(
                        "/procurment/transaction/Material-and-Services-Request/" +
                          values["BisnisUnitID"]
                      )
                    }
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    <BiArrowBack className="text-xl text-gray-800 pr-2" />
                    Kembali
                  </button>
                  <button
                    onClick={() => Kirim()}
                    disabled={mutationAdd.isLoading ? true : false}
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    {mutationAdd.isLoading ? (
                      <>
                        <svg
                          aria-hidden="true"
                          role="status"
                          className="inline mr-3 w-4 h-4 text-white animate-spin"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#E5E7EB"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentColor"
                          />
                        </svg>
                        Loading
                      </>
                    ) : (
                      "Simpan"
                    )}
                  </button>
                </div>

                {/* Semua field dibungkus SATU baris flex-wrap. Sebelumnya mereka anak
                    langsung dari `flex flex-col`, sehingga w-1/3 & w-1/2 tak pernah
                    benar-benar berdampingan — tiap field menempati barisnya sendiri
                    dengan lebar ragged (bug sama spt inser-jurnal.js & kas-bank).
                    Field w-full (catatan termin, data pendukung) otomatis memaksa
                    baris baru. */}
                <div className="flex flex-row flex-wrap items-start w-full">
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"BisnisUnit"}
                    value={values}
                    name={"BisnisUnitID"}
                    title={"Bisnis Unit"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={false}
                  />
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"Bagian"}
                    value={values}
                    name={"BagianID"}
                    title={"Bagian"}
                    onChange={bagianPilihan ? gantiBagian : customHandler}
                    onlyValues={bagianPilihan}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={!bagianPilihan}
                  />
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"dateOnly"}
                    value={values}
                    name={"DatePR"}
                    title={"Tanggal MSR"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={false}
                  />
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"TipePR"}
                    value={values}
                    name={"Tipe"}
                    title={"Tipe"}
                    onClick={customHandler}
                    onChange={ChangeTipe}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={false}
                  />
                </div>
                {showterminForm ? (
                  <div className="w-full px-3 mb-3">
                    <p className="text-xs text-gray-500">
                      Termin dikunci 0 di tahap MSR — pembagiannya ditentukan saat
                      Price Comparison, dan di sana totalnya wajib 100%.
                    </p>
                  </div>
                ) : null}
                {showterminForm || values.Termin1 > 0 ? (
                  <div className="w-1/3 termin-1">
                    <HrdInputGenerator
                      type={"text"}
                      value={values}
                      name={"Termin1"}
                      title={"Termin 1 (%)"}
                      onChange={changeHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={false}
                      errors={errors}
                      disabled={true}
                      showNominal={false}
                    />
                  </div>
                ) : null}
                {showterminForm || values.Termin2 > 0 ? (
                  <div className="w-1/3 termin-2">
                    <HrdInputGenerator
                      type={"text"}
                      value={values}
                      name={"Termin2"}
                      title={"Termin 2 (%)"}
                      onChange={changeHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={false}
                      errors={errors}
                      disabled={true}
                      showNominal={false}
                    />
                  </div>
                ) : null}
                {showterminForm || values.Termin3 > 0 ? (
                  <div className="w-1/3 termin-3">
                    <HrdInputGenerator
                      type={"text"}
                      value={values}
                      name={"Termin3"}
                      title={"Termin 3 (%)"}
                      onChange={changeHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={false}
                      errors={errors}
                      disabled={true}
                      showNominal={false}
                    />
                  </div>
                ) : null}
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"Sifat"}
                    value={values}
                    name={"Sifat"}
                    title={"Sifat Kebutuhan Barang"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={false}
                  />
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"KaryawanPemohon"}
                    value={values}
                    name={"Requester"}
                    title={"Pemohon"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={false}
                  />
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"PerkiraanHarga"}
                    value={values}
                    name={"PerkiraanHarga"}
                    title={"Perkiraan Harga"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={false}
                  />
                </div>
                <div className="w-1/2">
                  <HrdInputGenerator
                    type={"text"}
                    value={values}
                    name={"Remarks"}
                    title={"Keterangan"}
                    onChange={changeHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={false}
                  />
                </div>

                {/* Referensi Downpayment (uang muka) DIHILANGKAN dari MSR — 2026-08-20.
                    Metode baru: uang muka terbentuk OTOMATIS saat approval Price
                    Comparison final bila Term of Payment supplier terpilih = Cash
                    (lihat fitur uang-muka-otomatis-pc). Kolom DB
                    PurchaseRequisition."DownpaymentCashJournalID" + validasi backend
                    dibiarkan demi kompatibilitas data lama, tapi tak lagi diisi dari sini. */}
                <div className="w-full">
                  <div className="w-full px-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      {values["NamaFile"] && "Ganti "}
                      Data pendukung
                    </label>
                    <label
                      htmlFor={"NamaFile"}
                      className="block w-1/4 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    >
                      {values["NamaFile"] ? (
                        <span>
                          File Selected -{" "}
                          {values["NamaFile"].name
                            ? values["NamaFile"].name
                            : values["NamaFile"]}
                        </span>
                      ) : (
                        <span>Choose a file...</span>
                      )}
                    </label>

                    <input
                      type="file"
                      id={"NamaFile"}
                      key={"NamaFile"}
                      name={"NamaFile"}
                      style={{ visibility: "hidden" }}
                      className="block border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      onChange={(e) =>
                        customHandler(e.target.files[0], "NamaFile")
                      }
                    />
                  </div>
                </div>
                </div>

                {/* Section untuk error table */}
                <div className="my-4">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="text-lg font-semibold text-gray-800">
                      Detail Barang
                    </h3>
                    {tableError && (
                      <span className="text-red-600 text-sm font-medium">
                        ⚠️ {tableError}
                      </span>
                    )}
                  </div>
                  
                  {tableError && (
                    <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                      <div className="flex items-center">
                        <svg className="w-5 h-5 text-red-500 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        <span className="text-red-700">{tableError}</span>
                      </div>
                    </div>
                  )}
                  
                  {detail.length === 0 ? (
                    <div className="border-2 border-dashed border-red-300 rounded-lg p-8 text-center bg-red-50">
                      <svg className="w-12 h-12 text-red-400 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.998-.833-2.732 0L4.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                      </svg>
                      <h4 className="text-lg font-medium text-red-600 mb-2">Table Barang Kosong</h4>
                      <p className="text-gray-600 mb-4">Anda harus menambahkan minimal satu item barang sebelum menyimpan.</p>
                      <button
                        className="flex flex-row items-center justify-center bg-main-100 hover:bg-main-200 text-white font-semibold py-2 px-4 border border-main-100 rounded shadow"
                        onClick={() => ModalOpener({})}
                      >
                        <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                        </svg>
                        Tambah Item Barang
                      </button>
                    </div>
                  ) : (
                    <div className="border border-gray-200 rounded-lg overflow-hidden">
                      <DynamicTableSimple
                        data={detail.map((d) => ({
                          ...d,
                          Keterangan:
                            parseFloat(d.JumlahPO || 0) > 0 ? "Pembelian Barang" : "Barang Tersedia",
                        }))}
                        header={header}
                        Master={true}
                        OnClick={ModalOpener}
                        name={"Purchase Requisition"}
                        barang={barang.data}
                        edit={ModalEdit}
                        delete={ModalDelete}
                      />
                    </div>
                  )}
                </div>
              </div>
            </Card>
            <Modal
              size="lg"
              active={showModal}
              toggler={() => {
                setShowModal(true);
              }}
            >
              <ModalHeader
                className="mt-20"
                toggler={() => {
                  setShowModal(false);
                  setShowModalEdit(false);
                  setModalDetail(initialStateModal);
                }}
              >
                {showModalEdit ? "Edit Data" : "Tambah Data"}
              </ModalHeader>
              <ModalBody>
                <form className="w-full " onSubmit={submitHandler}>
                  {inputBuilder.map(
                    (
                      {
                        type,
                        name,
                        title,
                        handler,
                        modifiers,
                        size,
                        required,
                        disabled,
                        edit,
                        bagianID,
                      },
                      id
                    ) => {
                      if (!edit || showModalEdit) {
                        return (
                          <HrdInputGenerator
                            key={id}
                            type={type}
                            value={modalDetail}
                            name={name}
                            title={title}
                            onChange={handler}
                            touched={touched}
                            buttonTouched={buttonTouched}
                            modifiers={modifiers}
                            size={size}
                            required={required}
                            errors={errors}
                            disabled={disabled}
                            bagianID={bagianID}
                          />
                        );
                      }
                    }
                  )}
                  {/* Informasi tambahan untuk user */}
                  <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                    <div className="flex items-start">
                      <svg className="w-5 h-5 text-blue-500 mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                      </svg>
                      <div>
                        <p className="text-sm text-blue-700 font-medium">Informasi Stock:</p>
                        <p className="text-xs text-blue-600">
                          • Stock akan diambil otomatis dari sistem setelah memilih barang<br/>
                          • Jumlah PO akan dihitung otomatis berdasarkan ketersediaan stock
                        </p>
                      </div>
                    </div>
                  </div>
                </form>
                {qtynull && (
                  <div
                    className="p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50"
                    role="alert"
                  >
                    <span className="font-medium">Jumlah Pengajuan tidak boleh 0!</span>
                  </div>
                )}
                {barangexist && (
                  <div
                    className="p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50"
                    role="alert"
                  >
                    <span className="font-medium">
                      Barang sudah ada ditransaksi!
                    </span>
                  </div>
                )}
              </ModalBody>
              <ModalFooter>
                <Button
                  color="red"
                  buttonType="link"
                  onClick={() => {
                    setShowModal(false);
                    setShowModalEdit(false);
                    setModalDetail(initialStateModal);
                  }}
                  ripple="dark"
                >
                  Cancel
                </Button>

                <Button
                  color={isValid || !isValid ? "green" : "blueGray"}
                  disabled={mutation.isLoading}
                  onClick={async () => {
                    // Validasi mandatory fields
                    if (
                      !modalDetail["BarangID"] ||
                      modalDetail["BarangID"] === ""
                    ) {
                      toast.error("Barang wajib dipilih!", {
                        position: "bottom-right",
                        autoClose: 3000,
                        theme: "light",
                      });
                      return;
                    }

                    // Barang yang masih Transit In (PO belum diterima) atau Transit Out
                    // (pengeluaran belum di-Approve) di divisi yang sama tidak boleh diajukan
                    // lagi. Saat edit baris dengan barang yang tidak diganti, dilewati.
                    const barangTidakBerubah =
                      showModalEdit &&
                      detail?.[modalID]?.BarangID === modalDetail["BarangID"];
                    if (!barangTidakBerubah && values["BisnisUnitID"] && values["BagianID"]) {
                      try {
                        const res = await fetchGet(
                          `Procurement/GoodsTransitCek/${encodeURIComponent(values["BisnisUnitID"])}/${encodeURIComponent(values["BagianID"])}/${encodeURIComponent(modalDetail["BarangID"])}`
                        );
                        const cek = res?.data || res || {};
                        const tin = Array.isArray(cek.TransitIn) ? cek.TransitIn : [];
                        const tout = Array.isArray(cek.TransitOut) ? cek.TransitOut : [];
                        if (tin.length > 0 || tout.length > 0) {
                          setTransitBlock({ TransitIn: tin, TransitOut: tout });
                          return;
                        }
                      } catch (e) {
                        console.error("Cek transit gagal", e);
                      }
                    }
                    
                    if (
                      !modalDetail["Qty"] ||
                      modalDetail["Qty"] === "" ||
                      modalDetail["Qty"] === 0 ||
                      modalDetail["Qty"] === "0"
                    ) {
                      setqtynull(true);
                      toast.error("Jumlah Pengajuan wajib diisi!", {
                        position: "bottom-right",
                        autoClose: 3000,
                        theme: "light",
                      });
                      return;
                    } else {
                      setqtynull(false);
                      let newValues = [...detail];

                      // Pastikan semua perhitungan sudah benar sebelum menyimpan
                      const availableStock = calculateAvailableStock(
                        modalDetail.SaldoAkhir,
                        modalDetail.MinQty,
                        modalDetail.QtyTransit
                      );
                      
                      const finalModalDetail = {
                        ...modalDetail,
                        AvailableStock: availableStock,
                        Stock: availableStock, // Untuk display di table
                        JumlahPO: calculateJumlahPO(availableStock, modalDetail.Qty)
                      };

                      if (showModalEdit) {
                        newValues[modalID] = finalModalDetail;
                      } else {
                        newValues = detail
                          ? [...detail, finalModalDetail]
                          : [finalModalDetail];
                      }

                      const isBarangIDExists = hasDuplicateBarangID(newValues);
                      setbarangexist(isBarangIDExists);

                      if (isBarangIDExists) {
                        setbarangexist(true);
                        toast.error("Barang sudah ada dalam daftar!", {
                          position: "bottom-right",
                          autoClose: 3000,
                          theme: "light",
                        });
                      } else {
                        setbarangexist(false);
                        if (showModalEdit) {
                          setStockFinder(modalID);
                          mutationStock.mutate(newValues[modalID]["BarangID"]);
                        } else {
                          // Ambil data stock dari API untuk barang baru
                          mutationStock.mutate(finalModalDetail["BarangID"]);
                          setStockFinder(newValues.length - 1);
                        }
                        setDetail(newValues);
                        setModalDetail(initialStateModal);
                        setShowModal(false);
                        setShowModalEdit(false);
                        setTableError(""); // Reset error table
                        
                        toast.success("Barang berhasil ditambahkan!", {
                          position: "bottom-right",
                          autoClose: 2000,
                          theme: "light",
                        });
                      }
                    }
                  }}
                  ripple={isValid ? "light" : ""}
                >
                  {showModalEdit ? "Ubah" : "Tambah"}
                </Button>
              </ModalFooter>
            </Modal>

            <Modal
              size="regular"
              active={!!transitBlock}
              toggler={() => setTransitBlock(null)}
            >
              <ModalHeader toggler={() => setTransitBlock(null)}>
                Barang Masih Dalam Transit
              </ModalHeader>
              <ModalBody>
                <div className="text-sm text-gray-700 space-y-3">
                  {transitBlock?.TransitIn?.length > 0 && (
                    <div>
                      <p className="font-semibold">
                        Transit In — barang harus diterima dulu:
                      </p>
                      <ul className="list-disc ml-5">
                        {transitBlock.TransitIn.map((d) => (
                          <li key={d.PurchaseOrderID}>
                            {d.PurchaseOrderID} ({d.NamaSupplier || "-"}) — sisa{" "}
                            {d.QtySisa} {d.NamaSatuan}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  {transitBlock?.TransitOut?.length > 0 && (
                    <div>
                      <p className="font-semibold">
                        Transit Out — barang harus dikeluarkan (di-Approve) dulu:
                      </p>
                      <ul className="list-disc ml-5">
                        {transitBlock.TransitOut.map((d, i) => (
                          <li key={d.GoodsExpenditureID + i}>
                            {d.GoodsExpenditureID} ({d.NamaPeminta || "-"}) — {d.QtyKeluar}{" "}
                            {d.NamaSatuan}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  <p>
                    Barang ini belum bisa dipilih di MSR divisi yang sama. Selesaikan
                    penerimaan atau pengeluaran barang di atas terlebih dahulu.
                  </p>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="red" onClick={() => setTransitBlock(null)} ripple="dark">
                  Mengerti
                </Button>
              </ModalFooter>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsertPurchaseRequisitionPage;